import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 pt-20 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 grain opacity-[0.06] pointer-events-none" />
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(107,20,20,0.6),transparent_70%)] blur-2xl" />
      <form onSubmit={submit} className="relative w-full max-w-md bg-white/5 border border-white/10 backdrop-blur-xl rounded-md p-10 space-y-6">
        <div className="flex items-center gap-3">
          <div className="bg-white rounded-md p-1.5"><img src="/logo-mark.png" alt="Calium" className="h-10 w-10 object-contain" /></div>
          <div>
            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-[#C8956A]">Control Room</p>
            <h1 className="font-heading text-2xl font-black text-white tracking-tight">Admin sign in</h1>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-wider text-white/50 block mb-1">Email</label>
            <input data-testid="login-email-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-transparent border-b border-white/25 py-3 text-white font-body text-sm focus:outline-none focus:border-[#C8956A]" placeholder="admin@calium.in" />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-wider text-white/50 block mb-1">Password</label>
            <input data-testid="login-password-input" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full bg-transparent border-b border-white/25 py-3 text-white font-body text-sm focus:outline-none focus:border-[#C8956A]" placeholder="••••••••" />
          </div>
        </div>
        {error && <p data-testid="login-error" className="font-body text-sm text-[#F5D5B0] bg-[#6B1414]/60 border border-[#F5D5B0]/30 rounded-md p-3">{error}</p>}
        <button data-testid="login-submit-btn" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#F5D5B0] text-[#0A0A0A] py-3.5 font-body font-bold text-sm disabled:opacity-60 hover:-translate-y-0.5 transition-transform">
          <Lock size={14} /> {loading ? "Signing in..." : "Enter Control Room"} <ArrowRight size={14} />
        </button>
        <Link to="/admin/forgot" data-testid="login-forgot-link" className="block text-center font-mono text-[10px] uppercase tracking-wider text-white/50 hover:text-[#C8956A]">Forgot password?</Link>
      </form>
    </div>
  );
}
